<template>
  <v-card class="transfer-fee">
    <div style="padding: 24px">
      <div style="background: #fff !important;position: relative">
        <v-icon style="cursor: pointer;position: absolute; right: 0; top: 0" @click="$emit('close')">
          mdi-close
        </v-icon>
        <div style="background: #fff;display: grid; grid-template-columns: repeat(19, minmax(0, 1fr));">
          <!-- table left-->
          <div style="grid-column: span 11 / span 11" class="border-right">
            <h2 class="text-center ">GÓI HIỆN TẠI</h2>
            <p class="text-center font-italic">( Kiểm tra và xác định số tiền học viên được chuyển phí chuyển nhượng  )</p>
            <!-- Gói hiện tại -->
            <div class="timeline">
              <!-- THÔNG TIN GÓI CŨ -->
              <div class="timeline-item">
                <div class="timeline-dot">
                  <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.53736 20.4579L3.20551 21.1358V10.2047L0.180426 17.2984C-0.329979 18.5332 0.280017 19.9495 1.53736 20.4579ZM25.8127 15.9789L19.6381 1.48895C19.2522 0.581053 18.3434 0.0242105 17.3848 0C17.0611 0 16.725 0.0484212 16.4014 0.181579L7.22651 3.87368C6.29284 4.24895 5.72019 5.12053 5.69529 6.05263C5.68284 6.37947 5.74509 6.70632 5.88203 7.02105L12.0567 21.5111C12.4426 22.4311 13.3638 22.9879 14.3348 23C14.6585 23 14.9822 22.9395 15.2934 22.8184L24.4558 19.1263C25.7256 18.6179 26.3356 17.2016 25.8127 15.9789ZM8.19752 7.26316C7.51283 7.26316 6.95263 6.71842 6.95263 6.05263C6.95263 5.38684 7.51283 4.84211 8.19752 4.84211C8.88221 4.84211 9.44242 5.38684 9.44242 6.05263C9.44242 6.71842 8.88221 7.26316 8.19752 7.26316ZM5.70774 20.5789C5.70774 21.9105 6.82814 23 8.19752 23H10.0026L5.70774 12.9042V20.5789Z" fill="#6F44FF"/>
                  </svg>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class=" mt-1 font-weight-medium" style="color: #6F44FF;font-size: 15px">THÔNG TIN GÓI CŨ</span>
                  </div>
                  <!-- Package Details Table -->
                  <v-simple-table class="table-package-detail mt-3">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="first-child-th th-01 text-left font-weight-medium" rowspan="2">Sản phẩm/Combo</th>
                        <th class="text-center th-01 font-weight-medium" rowspan="2" style='width: 80px'>Tổng</th>
                        <th class="text-center pink-th-01" colspan="3">
                          <span class="font-weight-medium">Hạn học viên có</span> <span style="font-style: italic"> (tháng)</span>
                        </th>
                        <th class="text-center pink-th-02" colspan="3">
                          <span class="font-weight-medium"> Hạn học viên đã học</span> <span style="font-style: italic"> (tháng)</span>
                        </th>
                        <th class="last-child-th text-center font-weight-medium pink-th-03" style='width: 130px' rowspan="2">
                          Hạn học viên còn<br>và được chuyển
                        </th>
                      </tr>
                      <tr>
                        <th class="text-center pink-th-01 font-weight-medium" style='width: 80px'>Hạn gốc</th>
                        <th class="text-center pink-th-01 font-weight-medium" style='width: 85px'>Nhận phí</th>
                        <th class="text-center pink-th-01 font-weight-medium" style='width: 60px'>KM</th>
                        <th class="text-center pink-th-02 font-weight-medium" style='width: 80px'>Hạn gốc</th>
                        <th class="text-center pink-th-02 font-weight-medium" style='width: 80px'>Nhận phí</th>
                        <th class="text-center pink-th-02 font-weight-medium" style='width: 60px'>KM</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(pkg, index) in packageData" :key="index">
                        <td class="">{{ pkg.productName }}</td>
                        <td class="text-center ">{{ pkg.totalDuration }}</td>
                        <td class="text-center">{{ pkg.totalOriginDuration }}</td>
                        <td class="text-center">{{ pkg.totalFeeTransferDuration }}</td>
                        <td class="text-center">{{ pkg.totalPromotionDuration }}</td>
                        <td class="text-center">{{ pkg.passedOriginDuration }}</td>
                        <td class="text-center">{{ pkg.passedFeeTransferDuration }}</td>
                        <td class="text-center">{{ pkg.passedPromotionDuration }}</td>
                        <td class="text-center">
                            <span class="font-weight-bold"
                                  style="color: #5D62D1 !important;">
                              <span style="font-size: 17px !important;">
                                {{ pkg.durationToTransfer }}
                              </span>
                            </span>
                          <span  style="color: #5D62D1 !important;font-style: italic"> (tháng)</span>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <!--                    end table 1-->
                  <div class="mt-7 d-flex align-center" style="column-gap: 10px; margin-left: -29.5px !important;padding: 8px 0; background: white">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.44444 6.88889H8.33333C8.57407 6.88889 8.77333 6.81 8.93111 6.65222C9.08815 6.49519 9.16667 6.2963 9.16667 6.05556C9.16667 5.81482 9.08815 5.61556 8.93111 5.45778C8.77333 5.30074 8.57407 5.22222 8.33333 5.22222H4.44444C4.2037 5.22222 4.00481 5.30074 3.84778 5.45778C3.69 5.61556 3.61111 5.81482 3.61111 6.05556C3.61111 6.2963 3.69 6.49519 3.84778 6.65222C4.00481 6.81 4.2037 6.88889 4.44444 6.88889ZM11.9444 15.8333H15.8333C16.0741 15.8333 16.2733 15.7548 16.4311 15.5978C16.5881 15.44 16.6667 15.2407 16.6667 15C16.6667 14.7593 16.5881 14.5604 16.4311 14.4033C16.2733 14.2456 16.0741 14.1667 15.8333 14.1667H11.9444C11.7037 14.1667 11.5048 14.2456 11.3478 14.4033C11.19 14.5604 11.1111 14.7593 11.1111 15C11.1111 15.2407 11.19 15.44 11.3478 15.5978C11.5048 15.7548 11.7037 15.8333 11.9444 15.8333ZM11.9444 13.0556H15.8333C16.0741 13.0556 16.2733 12.9767 16.4311 12.8189C16.5881 12.6619 16.6667 12.463 16.6667 12.2222C16.6667 11.9815 16.5881 11.7822 16.4311 11.6244C16.2733 11.4674 16.0741 11.3889 15.8333 11.3889H11.9444C11.7037 11.3889 11.5048 11.4674 11.3478 11.6244C11.19 11.7822 11.1111 11.9815 11.1111 12.2222C11.1111 12.463 11.19 12.6619 11.3478 12.8189C11.5048 12.9767 11.7037 13.0556 11.9444 13.0556ZM6.38889 16.6667C6.62963 16.6667 6.82889 16.5881 6.98667 16.4311C7.1437 16.2733 7.22222 16.0741 7.22222 15.8333V14.4444H8.61111C8.85185 14.4444 9.05111 14.3656 9.20889 14.2078C9.36593 14.0507 9.44444 13.8519 9.44444 13.6111C9.44444 13.3704 9.36593 13.1711 9.20889 13.0133C9.05111 12.8563 8.85185 12.7778 8.61111 12.7778H7.22222V11.3889C7.22222 11.1481 7.1437 10.9489 6.98667 10.7911C6.82889 10.6341 6.62963 10.5556 6.38889 10.5556C6.14815 10.5556 5.94926 10.6341 5.79222 10.7911C5.63445 10.9489 5.55556 11.1481 5.55556 11.3889V12.7778H4.16667C3.92593 12.7778 3.72704 12.8563 3.57 13.0133C3.41222 13.1711 3.33333 13.3704 3.33333 13.6111C3.33333 13.8519 3.41222 14.0507 3.57 14.2078C3.72704 14.3656 3.92593 14.4444 4.16667 14.4444H5.55556V15.8333C5.55556 16.0741 5.63445 16.2733 5.79222 16.4311C5.94926 16.5881 6.14815 16.6667 6.38889 16.6667ZM11.75 8.25C11.9167 8.41667 12.1111 8.5 12.3333 8.5C12.5556 8.5 12.75 8.41667 12.9167 8.25L13.8889 7.27778L14.8889 8.27778C15.037 8.42593 15.2222 8.5 15.4444 8.5C15.6667 8.5 15.8611 8.41667 16.0278 8.25C16.1759 8.10185 16.25 7.91185 16.25 7.68C16.25 7.44889 16.1759 7.25 16.0278 7.08333L15.0556 6.05556L16.0556 5.05556C16.2037 4.90741 16.2778 4.72222 16.2778 4.5C16.2778 4.27778 16.1944 4.08333 16.0278 3.91667C15.8611 3.75 15.6667 3.66667 15.4444 3.66667C15.2222 3.66667 15.0278 3.75 14.8611 3.91667L13.8889 4.88889L12.8889 3.88889C12.7407 3.74074 12.5556 3.66667 12.3333 3.66667C12.1111 3.66667 11.9167 3.75 11.75 3.91667C11.5833 4.08333 11.5 4.27778 11.5 4.5C11.5 4.72222 11.5833 4.91667 11.75 5.08333L12.7222 6.05556L11.7222 7.08333C11.5741 7.25 11.5 7.44444 11.5 7.66667C11.5 7.88889 11.5833 8.08333 11.75 8.25ZM2.22222 20C1.61111 20 1.08778 19.7826 0.652222 19.3478C0.217407 18.9122 0 18.3889 0 17.7778V2.22222C0 1.61111 0.217407 1.08778 0.652222 0.652222C1.08778 0.217407 1.61111 0 2.22222 0H17.7778C18.3889 0 18.9122 0.217407 19.3478 0.652222C19.7826 1.08778 20 1.61111 20 2.22222V17.7778C20 18.3889 19.7826 18.9122 19.3478 19.3478C18.9122 19.7826 18.3889 20 17.7778 20H2.22222Z" fill="#6F44FF"/>
                    </svg>

                    <span class="font-weight-medium" style="color: #6F44FF;font-size: 15px">GIÁ TRỊ DÙNG ĐỂ QUY ĐỔI</span>
                  </div>
                  <!-- Transfer Value Table -->
                  <div v-if="isEqualMoney" class="d-flex justify-end mt-3 mb-1">
                    <div>
                      <v-select
                          :items="listConversionMethod"
                          v-model="conversionMethod"
                          :disabled="isDetail"
                          outlined
                          @change="handleConversionMethod()"
                          class="custom-select-outlined-submodule1"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table class="table-package-detail mt-2">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="first-child-th th-01 text-left font-weight-medium">Sản phẩm</th>
                        <th style="width: 160px" class="th-01 text-center font-weight-medium">Căn cứ quy đổi</th>
                        <th style="width: 140px" class="th-01 text-center font-weight-medium">
                          Đơn giá / Thời hạn<br>
                          <span style="font-size: 11px !important;font-style: italic !important;">(VNĐ / Tháng)</span>
                        </th>
                        <th style="width: 140px" class="pink-th-03 text-center font-weight-medium">
                          Giá trung bình <br> 1 tháng
                        </th>
                        <th style="width: 180px !important;" class="pink-th-03 text-center font-weight-medium">
                          Số tiền còn lại <br> của sản phẩm
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(pkg, index) in packageData" :key="index">
                        <td> {{ pkg.productName }}</td>
                        <td class="text-center"> {{  pkg.transferOrigin }}</td>
                        <td class="text-center">
                          {{ isConversionMonth ? '--' : (formatCurrency(pkg.totalPrice)  +' / '+ pkg.totalOriginDurationFull) }}
                        </td>
                        <td class="text-center"> {{ isConversionMonth ? '--' : formatCurrency(pkg.priceUnit) }}</td>
                        <td class="text-center">
                          <template v-if="isConversionMonth">
                            --
                          </template>
                          <template v-else>
                            <div class="d-flex justify-center" style="column-gap: 6px">
                              <div v-if="!isEditAmount && !isDetail && isCheckAuthorization" style="cursor: pointer"
                                   @click="showEditAmount(pkg)">
                                <v-icon color="#6F44FF" size="18">mdi-pencil</v-icon>
                              </div>
                              <div v-if="!isEditAmount" class=" font-weight-bold" style="font-size: 14px !important;color: #5D62D1 !important;margin-top: 2px !important;">
                                {{ formatCurrency(pkg.amountToTransfer) }} VNĐ
                              </div>
                              <div class="d-flex justify-center align-center" style="column-gap: 6px;width: 100%" v-else>
                                <v-text-field
                                    type="number"
                                    dense
                                    style="width: 100px !important;"
                                    class="text-field-number"
                                    @input="validateAmount(pkg, index)"
                                    v-model="pkg.amountToTransfer"
                                    placeholder="Nhập số"
                                    :error="!!pkg.amountError"
                                    :error-messages="pkg.amountError"
                                />
                                <span  style="cursor: pointer"
                                       @click="cancelEditAmount()">
                                <v-icon color="#6F44FF" size="20">mdi-close</v-icon>
                            </span>
                              </div>
                            </div>
                          </template>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <!--                      end table 2-->
                  <div class="mt-6 d-flex align-center" style="column-gap: 10px; margin-left: -26.5px !important;padding: 8px 0; background: white">
                    <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.45972 8.33889C3.78389 7.71611 2.92338 7.07222 2.92338 6.06944C2.92338 4.91889 4.11395 4.11667 6.10609 4.11667C8.20432 4.11667 8.98232 5.01389 9.05304 6.33333H11.6582C11.5756 4.51778 10.3379 2.85 7.87426 2.31167V0H4.33792V2.28C2.05108 2.72333 0.212181 4.05333 0.212181 6.09056C0.212181 8.52889 2.46365 9.74278 5.75246 10.45C8.69941 11.0833 9.2888 12.0122 9.2888 12.9939C9.2888 13.7222 8.7112 14.8833 6.10609 14.8833C3.6778 14.8833 2.72299 13.9122 2.59332 12.6667H0C0.141454 14.9783 2.07466 16.2767 4.33792 16.7094V19H7.87426V16.7306C10.1729 16.34 12 15.1472 12 12.9833C12 9.98556 9.13556 8.96167 6.45972 8.33889Z" fill="#6F44FF"/>
                    </svg>
                    <span class="font-weight-medium" style="color: #6F44FF;font-size: 15px">SỐ TIỀN CÒN LẠI </span>
                  </div>
                  <!--                  end time 03-->
                  <!--                  amount -->
                  <div class="mt-3 ">Tổng số tiền còn lại: <span class="font-weight-medium" style="font-size: 16px;color: #6F44FF">{{ isConversionMonth ? '- -' : formatCurrency(totalRemainAmount) }} VNĐ</span></div>
                  <!--                  end amount-->
                </div>
              </div>
            </div>
          </div>
          <!--           table right-->
          <div style="grid-column: span 8 / span 8" class="px-3">
            <h2 class="text-center">GÓI MUỐN CHUYỂN</h2>
            <p class="text-center font-italic">( Chọn loại chuyển , sản phẩm nhận phí và thông tin con nhận phí  )</p>
            <div class="mt-2 mb-1 px-2 d-flex align-center" style="justify-content: space-between;">
              <v-radio-group v-model="typeTransfer" :disabled="isDetail" row>
                <v-radio label="Chuyển phí" :value="1" color="green" class="pr-3"></v-radio>
                <v-radio label="Chuyển nhượng" :value="2" color="green"></v-radio>
              </v-radio-group>
              <v-radio-group v-model="paymentMethod" :disabled="isDetail" row>
                <v-radio label="Ngang tiền" :value="1" color="green" class="pr-3"></v-radio>
                <v-radio label="Thanh toán thêm" :value="2" color="green"></v-radio>
              </v-radio-group>
            </div>
            <div class="d-flex align-center mt-3 mb-4"
                 style="color: #6F44FF;font-weight: bold;font-size: 15px;background:rgba(212, 213, 255, 0.38); padding: 4px 10px;border-radius: 8px">
              <v-icon style="color: #6F44FF;margin-right: 8px">
                mdi-sync-circle
              </v-icon>
              <div style="margin-top: 2px">
                LỌC VÀ CHỌN SẢN PHẨM NHẬN PHÍ
              </div>
            </div>
            <!--  start product-->
            <div>
              <div v-if="products && products.length">
                <v-row
                    v-for="(product, indexProd) in products"
                    :key="indexProd"
                >
                  <!--Sản phẩm gia sư-->
                  <v-col
                      class="ma-0"
                      v-if="product.type == 'tutor' || product.productType == 'sku_tutor'">
                    <TutorProduct
                        :payment-method="paymentMethod"
                        :total-remain-amount="totalRemainAmount"
                        :is-detail-order='isDetail'
                        :product="product"
                        :indexProd="indexProd"
                        :curriculums="curriculums"
                        :teacherTypes="teacherTypes"
                        :curriculumObj="curriculumObj"
                        :classes="classes"
                        :teacherTypeObj="teacherTypeObj"
                        :classTypeObj="classTypeObj"
                        :innerWidth="innerWidth"
                        :url-o-m-s="urlOMS"
                        :skuTutors="skuTutors"
                        @deleteProduct="deleteProduct($event)"
                    />
                    <div v-if="paymentMethod === 1" class="mt-6 font-weight-medium">
                      Giá một buổi của gói nhận phí :
                      <span style="padding-left: 5px;color:#129700" class="font-weight-medium">
                  {{ totalMoneyTutor !== 0 ? formatCurrency(totalMoneyTutor) + ' VNĐ' : '--' }}</span>
                    </div>
                  </v-col>
                  <!--Sản phẩm gia sư-->

                  <!--Sản phẩm khóa học-->
                  <v-col  v-if="product.type == 'duo'">
                    <DuoProduct
                        :is-conversion-month="isConversionMonth"
                        :is-detail-order='isDetail'
                        :product="product"
                        :indexProd="indexProd"
                        :subjectObj="subjectObj"
                        :levelObj="levelObj"
                        :gradeObj="gradeObj"
                        :activeTypeObj="activeTypeObj"
                        :innerWidth="innerWidth"
                        :skuDuos="skuDuos"
                        @deleteProduct="deleteProduct($event)"
                    />
                  </v-col>
                  <!--Sản phẩm khóa học-->

                  <!--Sản phẩm combo-->
                  <v-col v-if="product.type == 'combo'">
                    <ComboProduct
                        :is-detail-order='isDetail'
                        :product="product"
                        :indexProd="indexProd"
                        :skuCombos="skuCombos"
                        :subjectObj="subjectObj"
                        :innerWidth="innerWidth"
                        @viewDetailCombo="viewDetailCombo($event)"
                        @deleteProduct="deleteProduct($event)"
                    />
                  </v-col>
                  <!--Sản phẩm combo-->
                </v-row>
              </div>
              <div class="d-flex align-center justify-space-between py-4">
                <div v-if="paymentMethod === 2 " class="font-weight-medium">
                  TỔNG GIÁ TRỊ MỚI : <span style="padding-left: 5px;color:#129700" class="font-weight-medium">
                  {{ totalMoney !== 0 ? formatCurrency(totalMoney) + ' VNĐ' : '--' }}</span>
                </div>
                <div v-if="paymentMethod === 1 && products && products.filter(item => item.type === 'tutor').length === 0" class="font-weight-medium">
                  SỐ TIỀN CÒN THỪA : <span style="padding-left: 5px;color:#129700" class="font-weight-medium">
                  {{ isConversionMonth ? '-- VNĐ' : (totalMoney !== 0 ? formatCurrency(parseInt(totalRemainAmount) - parseInt(totalMoney)) + ' VNĐ' : '--') }}</span>
                </div>
                <template v-if="!isDetail">
                  <div v-if="paymentMethod === 2 || (paymentMethod === 1 && products && products.filter(item => item.type === 'tutor').length === 0)" class="text-center">
                    <v-menu :offset-y="true" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            min-width="70"
                            height="32"
                            class="mr-0"
                            color="#7B82FF"
                            style="text-transform: none !important; color: white !important;"
                        >
                          Chọn sản phẩm nhận phí +
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="addProduct('duo')">
                          <v-list-item-title>Khóa học</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="paymentMethod === 2 || products.length === 0 || paymentMethod === 1 && isTutor" @click="addProduct('tutor')">
                          <div>
                            <v-list-item-title>Gia sư</v-list-item-title>
                            <div v-if="paymentMethod === 1" style="font-style: italic !important;font-size: 11px !important;">
                              ( Chỉ được chuyển sang 1 gói gia sư )
                            </div>
                          </div>
                        </v-list-item>
                        <v-list-item @click="addProduct('combo')">
                          <v-list-item-title>Combo</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="typeTransfer === 2 ">
              <div class="d-flex align-center mt-6 mb-4 "
                   style="color: #6F44FF;font-weight: bold;font-size: 15px;background:rgba(212, 213, 255, 0.38); padding: 4px 10px;border-radius: 8px">
                <v-icon style="color: #6F44FF;margin-right: 8px">mdi-account-check</v-icon>
                <div style="margin-top: 2px">THÔNG TIN KHÁCH HÀNG NHẬN PHÍ</div>
              </div>

              <!--                <div class=" mt-3 mb-4" style="color: #6F44FF;font-weight: bold;font-size: 16px;"><v-icon style="color: #6F44FF;margin-right: 10px">mdi-account-check</v-icon>THÔNG TIN KHÁCH HÀNG NHẬN PHÍ</div>-->
              <div class="mt-10 pl-4 mb-2" style="color:#666666; font-weight: bold;font-size: 14px;">MÃ KHÁCH HÀNG HOẶC SĐT <span style="color: red">*</span></div>
              <validation-observer ref="validatorPhone" tag="div" class="pl-4">
                <validation-provider v-slot="{ errors }" :rules="{ requiredContact: true }" name="Thông tin khách hàng" :vid="`phoneOrICD`">
                  <v-text-field
                      type="text"
                      :error-messages="errors && errors.length > 0? errors : errorContact"
                      dense
                      style="width:43%"
                      class="text-field-number"
                      v-model="phoneOrICD"
                      :disabled="isDetail"
                      placeholder="Nhập số"
                  />
                </validation-provider>
              </validation-observer>
            </div>
          </div>
        </div>
        <!-- Footer warning -->
        <!-- Action buttons -->
        <div v-if="!isDetail" class=" d-flex justify-lg-end mt-8">
          <v-btn
              class="mr-4"
              color="grey darken-1"
              dark
              style="color: #FFF; border-radius: 999px !important; "
              @click="$emit('close')"
          >
            HỦY BỎ
          </v-btn>
          <v-btn
              :disabled="products === null
              || totalRemainAmount === 0
            || paymentMethod === 1 && totalRemainAmount < totalMoney && !isTutor && conversionMethod === 1
            || packageData.some(pkg => !!pkg.amountError)"
              class="btn-next"
              @click="handlePreview()"
          >
            TIẾP TỤC
          </v-btn>
        </div>
      </div>
    </div>
    <v-dialog
        v-if="isShowDetailCb"
        v-model="isShowDetailCb"
        persistent
        max-width="750"
    >
      <DetailCombo
          :comboIDSelect="comboIDSelect"
          :skuCombos="skuCombos"
          @close="closeDetailCb"
      />
    </v-dialog>
    <v-dialog v-if="isPopupTransferPreview" v-model="isPopupTransferPreview" width='70vw' persistent>
      <v-card class="ticket-card pa-6">
        <div class="text-center mb-6" style="font-weight: 600; font-size: 18px">VUI LÒNG XÁC NHẬN THÔNG TIN CHUYỂN PHÍ</div>
        <preview-transfer-duo
            :transfer-fee-detail="transferFeeDetail"
        />
        <div class="mt-4 d-flex justify-center">
          <v-btn
              class="mr-4"
              color="grey darken-1"
              dark
              style="color: #FFF; border-radius: 999px !important; "
              @click="isPopupTransferPreview = false"
          >
            HỦY BỎ
          </v-btn>
          <v-btn
              style="background:#FF4C00 !important;color: #FFF; border-radius: 999px !important; "
              color="#FF4C00;"
              @click="handleTransferProduct()"
          >
            XÁC NHẬN CHUYỂN PHÍ
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>

import {addProduct_C, verifyDataProduct} from "../../helper/FuncProduct";
import TransferFeeDuo from "../../repository/TransferFeeDuo";
import TutorProduct from "../transfer-fee-duo/BlockProduct/TutorProduct.vue";
import ComboProduct from "../transfer-fee-duo/BlockProduct/ComboProduct.vue";
import DetailCombo from "../transfer-fee-duo/BlockProduct/DetailCombo.vue";
import DuoProduct from "../transfer-fee-duo/BlockProduct/DuoProduct.vue";
import _ from "lodash";
import TransferRepository from "../../repository/TransferRepository";
import PreviewTransferDuo from "../transfer-fee-duo/PreviewTransferDuo.vue";
import TokenService from "../../../../../src/helpers/token";

export default {
  name: 'TransferFeeDuo',
  components: {
    PreviewTransferDuo, DetailCombo, TutorProduct, ComboProduct, DuoProduct},
  props: {
    isCheckAuthorization: {
      type: Boolean,
      default: false,
    },
    packageCodes: {
      type: Array,
      default: () => { [] },
    },
    idTransfer: {
      type: String,
      default: null,
    },
    isPopupTransferFee: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Object,
      default: () => {
      },
    },
    urlERP: {
      type: String,
      default: process.env.VUE_APP_SORT_CLASS,
    },
    urlOMS: {
      type: String,
      default: process.env.VUE_APP_API_OMS,
    },
    urlCRM: {
      type: String,
      default: process.env.VUE_APP_API_ERP,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    products: [],
    transferFeeDetail: {},
    isPopupTransferPreview: false,
    phoneOrICD: null,
    errorContact: '',
    typeTransfer: 1,
    paymentMethod: 1,
    packageData: [],
    packageDataClone: [],
    teacherTypes: [],
    classes: [],
    skuTutors: [],
    skuDuos: [],
    skuCombos: [],
    subjects: [],
    subjectObj: {},
    classTypeObj: {},
    curriculumObj: {},
    teacherTypeObj: {},
    curriculums: [],
    levelObj: {
      CO_BAN: 'Cơ bản',
      NANG_CAO: 'Nâng cao',
    },
    gradeObj: {},
    activeTypeObj: {
      student_self_activation: 'Học sinh tự kích hoạt',
      on_order_activation: 'Kích hoạt khi lên đơn',
      scheduled_activation: 'Hẹn ngày kích hoạt',
    },
    comboIDSelect: null,
    isShowDetailCb:false,
    // totalRemainAmount: 0,
    recordId: null,
    isEditAmount: false,
    conversionMethod: 1, // 1: Quy đổi trung bình, 2: Quy đổi ngang tháng
    listConversionMethod: [
      {text: 'Quy đổi trung bình', value: 1},
      {text: 'Quy đổi ngang tháng', value: 2},
    ]
  }),
  async created() {
    await Promise.all([
      this.getPackageData(),
      this.getListAttributes(),
      this.getCurriculumAttributes(),
    ]);
    if(this.isDetail && this.idTransfer) {
      await this.getTutorSku()
      await this.getPreviewTransferApi(this.idTransfer, 'detail')
    }
  },
  watch: {
    phoneOrICD(val) {
      if(val !== this.phoneCloneOrICD) {
        this.errorContact = null;
      }
    },
    async paymentMethod() {
      if(!this.isDetail) {
        await Promise.all([
          this.getDuoSku(),
          this.getComboSku()
        ])
      }
      this.products = []
    },
    isEqualMoney() {
      if (!this.isEqualMoney) {
        this.conversionMethod = 1;
      }
    },
  },
  computed: {
    getUser() {
      const username = TokenService.getUserName();
      return username ? username.toLowerCase() : username;
    },
    isEqualMoney() {
      if(this.packageData.length === 1 && this.products.length === 1 && this.paymentMethod === 1) {
        const oldProduct = this.packageData[0];
        const newProduct = this.products[0];
        if (newProduct.type === 'duo' && oldProduct.productType === 'sku_duo' && oldProduct.originTotalPrice === this.totalMoney && oldProduct.totalOriginDurationFull === newProduct.duration) {
          return true;
        }
      }
      return false;
    },
    isConversionMonth() {
      return this.conversionMethod === 2;
    },
    isDuo() {
      return this.products.every(item => item.type === 'duo');
    },
    isTutor() {
      return this.products.every(item => item.type === 'tutor');
    },
    innerWidth() {
      return window.innerWidth;
    },
    totalMoney() {
      return this.products.reduce((accumulator, product) => {
        return accumulator + parseInt((product.type === 'tutor' && this.paymentMethod === 1 ? product.pricePerLesson : product.price) * product.quantity);
      }, 0);
    },
    totalRemainAmount() {
      if(this.packageData && this.packageData.length > 0) {
        return this.packageData.reduce((accumulator, pkg) => {
          return accumulator + ( pkg.amountToTransfer ? parseInt(pkg.amountToTransfer) : 0);
        }, 0);
      }
      return 0;
    },
    totalMoneyTutor() {
      return this.products.reduce((accumulator, product) => {
        console.log(accumulator,product.pricePerLesson, 'product.pricePerLesson')
        return accumulator + parseInt(product.pricePerLesson);
      }, 0);
    },
  },
  methods: {
    async handleConversionMethod() {
      if(this.conversionMethod === 1) {
        await this.getPackageData({ is_equal_month: false });
      } else {
        await this.getPackageData({ is_equal_month: true });
      }
    },
    validateAmount(pkg, index) {
      // pkg.amountToTransfer = pkg.amountToTransfer.replace(/[^0-9\.]/g,'');
      if (parseFloat(pkg.amountToTransfer) > parseFloat(pkg.totalPrice)) {
        pkg.amountError = 'Số tiền phải nhỏ hơn hoặc bằng ' + pkg.totalPrice;
        // pkg.amountToTransfer = pkg.totalPrice;
      } else {
        pkg.amountError = '';
      }
      if (this.packageDataClone && this.packageDataClone.length > 0
          && this.packageDataClone[index].amountToTransfer != pkg.amountToTransfer) {
        pkg.transferOrigin = this.getUser + ' nhập';
      } else {
        pkg.transferOrigin = this.packageDataClone[index].transferOrigin;
      }
    },

    async getTutorSku() {
      const params = {
        product_type: 'tutor',
        include_price_policy: 1,
        transaction_status: 'selling',
        status: 'active',
      };
      const res = await TransferFeeDuo.advanceSearchForComboV2(this.urlOMS,params);
      this.skuTutors = res.data || [];
    },
    showEditAmount() {
      this.isEditAmount = true
      this.packageDataClone = _.cloneDeep(this.packageData)
    },
    cancelEditAmount() {
      this.isEditAmount = false
      this.packageData = _.cloneDeep(this.packageDataClone)
    },
    async handleTransferProduct() {
      try {
        const response = await TransferFeeDuo.changeStatusTransferApi(this.urlCRM, this.recordId, {
          status: 2
        })
        if(response.success) {
          this.isPopupTransferPreview = false
          this.$emit('close')
          this.$swal({
            icon: 'success',
            type: 'success',
            title: 'Đã thực hiện chuyển thành công.',
            showConfirmButton: false,
            timer: 3500,
          });
        }else {
          this.$swal({
            icon: 'error',
            type: 'error',
            title: response.data.message,
            showConfirmButton: true,
            timer: 3500,
          });
        }
      }catch (e) {
        console.log(e)
      }
    },
    async getPackageData(data = {}) {
      // const loader = this.$loading.show()
      try {
        const params = {
          package_codes: this.packageCodes,
          ...data
        }
        const response = await TransferFeeDuo.getChosePackagesTransferApi(this.urlCRM,params )
        if(response.success) {
          this.$emit('closeSelected')
          this.packageData = response.data && response.data.oldPackageList ? response.data.oldPackageList : []
          this.packageData.forEach(pkg => {
            // eslint-disable-next-line no-prototype-builtins
            if (!pkg.hasOwnProperty('amountError')) {
              this.$set(pkg, 'amountError', '');
            }
          });

          // this.totalRemainAmount = response.data && response.data.totalRemainAmount ? response.data.totalRemainAmount : 0
          if(this.totalRemainAmount !== null) {
            await Promise.all([
              this.getDuoSku(),
              this.getComboSku()
            ])
          }
        }else {
          this.packageData = []
          this.this.packageData= 0
        }
      }catch (e) {
        console.log(e)
      } finally {
        // loader.hide()
      }
    },
    async formatProducts(products) {
      let results = await Promise.all(products.map(async (item) => {
        const type = item.productType.split('_')[1];
        let skus = type == 'tutor' ? this.skuTutors : this.skuDuos;
        if (type == 'combo') skus = this.skuCombos;
        const productSKU = skus.find(sku => sku.id === item.productId);
        return {
          id: item.id,
          comboId: item.comboId,
          activeType: item.activeType,
          type: item.productType.split('_')[1],
          learningPathId: item.learningPathId,
          curriculumId: productSKU.curriculumId,
          teacherType: productSKU.teacherTypeId,
          productId: item.productType.split('_')[1] == 'combo' ? item.comboId : item.productId,
          productName: productSKU.name,
          quantity: item.quantity,
          duration: item.duration || null,
          price: item.price,
          discount: (item.quantity || 0) * (item.price || 0) - (item.intoMoney || 0),
          intoMoney: item.intoMoney,
          customerId: item.customerId,
          isNew: item.orderType === 1 ? true : false,
          isExtend: item.orderType === 2 ? true : false,
          packageOptions: [],
          products: skus,
          maxPrice: null,
          minPrice: null,
          package: `${productSKU.classTypeId}-${productSKU.numOfLesson}`,
          priceType: 'unchanged',
          pricePerLesson: item.pricePerLesson || 0
        };
      }));
      return results;
    },

    viewDetailCombo(id) {
      this.comboIDSelect = id;
      this.isShowDetailCb = true;
    },
    closeDetailCb() {
      this.isShowDetailCb = false;
      this.comboIDSelect = null;
    },
    async getCurriculumAttributes() {
      const res = await TransferFeeDuo.getCurriculumAttributes(this.urlCRM);
      this.curriculums = res.data;
      res.data.forEach((item) => {
        this.curriculumObj[item.id] = item.title;
      })
    },
    async getListAttributes() {
      const res = await TransferFeeDuo.getProductAttributes(this.urlOMS);
      this.teacherTypes = res.data.teacherTypes;
      this.classes = res.data.classTypes;
      res.data.classTypes.forEach((item) => {
        this.classTypeObj[item.id] = item.name;
      });
      res.data.teacherTypes.forEach((item) => {
        this.teacherTypeObj[item.id] = item.name;
      })
      this.subjects = res.data.subjects;
      res.data.subjects.forEach((item) => {
        this.subjectObj[item.id] = item.name;
      });
      this.grades = res.data.grades;
      res.data.grades.forEach((item) => {
        this.gradeObj[item.id] = item.name;
      });
    },
    async getDuoSku() {
      const params = {
        product_type: 'duo',
        include_price_policy: 1,
        transaction_status: 'selling',
        status: 'active',
        is_from_crm: 1,
      };
      if(this.totalRemainAmount && this.paymentMethod === 1) {
        params.lte_price = this.totalRemainAmount;
      }
      const res = await TransferFeeDuo.advanceSearchForComboV2(this.urlOMS,params);
      this.skuDuos = res.data;
    },
    async getComboSku() {
      const params = {
        product_type: 'combo',
        include_price_policy: 1,
        transaction_status: 'selling',
        status: 'active',
        is_from_crm: 1,
      };
      if(this.totalRemainAmount  && this.paymentMethod === 1) {
        params.lte_price = this.totalRemainAmount;
      }
      const res = await TransferFeeDuo.advanceSearchForComboV2(this.urlOMS,params);
      this.skuCombos = res.data;
    },
    addProduct(type = "tutor") {
      let listSKU = [];
      if (type === "tutor") listSKU = this.skuTutors;
      if (type === "duo") listSKU = this.skuDuos;
      if (type === "combo") listSKU = this.skuCombos;
      addProduct_C(this.products, type, listSKU)
    },
    deleteProduct(data) {
      this.products.splice(data.index, 1);
    },
    formatDataProduct() {
      if(this.products) {
        let totalPrice = 0;
        return this.products.map((item) => {
          totalPrice += ((item.price * item.quantity) - item.discount);
          if (totalPrice < 0) totalPrice = 0;
          const product = {
            orderType: item.isNew ? 1 : 2,
            productId: item.productId,
            productType: `sku_${item.type}`,
            quantity: item.quantity ? item.quantity : 1,
            customerId: null,
            price: item.price,
            intoMoney: item.price * item.quantity > 0 ? item.price * item.quantity : 0,
          };
          if (item.type === 'duo') {
            product.activeType = item.activeType;
          }
          if (item.type === 'tutor') {
            product.learningPathId = item.learningPathId;
          }
          if (item.type === 'tutor') {
            product.pricePerLesson = item.pricePerLesson;
          }
          return product;
        });
      }
      return []
    },
    async checkPhoneOrICD() {
      let idCD = null
      const params = {keyword: this.phoneOrICD}
      this.phoneCloneOrICD = _.cloneDeep(this.phoneOrICD)
      const res = await TransferRepository.checkPhoneOrICD(this.urlCRM, params);
      if (res.data && !res.errors) {
        if (res.data.data && !res.data.error) {
          idCD = res.data.data.id;
        }
      } else {
        this.$swal({
          icon: 'error',
          type: 'error',
          title: '( Số điện thoại này chưa tồn tại trên hệ thống. Vui lòng thêm contact trên crm )',
          showConfirmButton: true,
          timer: 2500,
        });
      }
      return idCD
    },
    async getPreviewTransferApi(id, type = 'preview') {
      const loader = this.$loading.show();
      try {
        const response = await TransferFeeDuo.getPreviewApi(this.urlCRM, id, type === 'detail' ? { type: type  } : null);
        if (response.success) {
          if(type === 'detail') {
            const data = response.data ? response.data : {};
            this.packageData = data && data.oldPackageList ? data.oldPackageList : []
            this.typeTransfer = data && data.typeTransfer ? data.typeTransfer.id : 1
            this.paymentMethod = data && data.paymentMethod ? data.paymentMethod.id : 1
            this.conversionMethod = data && data.conversionMethod ? data.conversionMethod.id : 1
            const newProductList = data && data.newProductList ? data.newProductList : [];
            this.products = await this.formatProducts(newProductList);
            this.phoneOrICD = data && data.mobile ? data.mobile : null;
          }else {
            this.isPopupTransferPreview = true;
            this.transferFeeDetail = response.data;
          }
        } else {
          this.$swal({
            icon: 'error',
            type: 'error',
            text: response.message,
            showConfirmButton: true,
            timer: 2500,
          });
        }
      }catch (e) {
        console.log(e)
      }finally {
        loader.hide()
      }
    },
    async handlePreview() {
      if(this.products && this.products.length > 0) {
        const verify = verifyDataProduct(this, this.products);
        if (verify) return;
        const products = this.formatDataProduct()
        const contactId = this.student && this.student.contact_id ? this.student.contact_id : null;
        let phoneOrIcd = null;
        if(this.typeTransfer === 2) {
          const validPhone = await this.$refs.validatorPhone.validate();
          if (validPhone) {
            phoneOrIcd = await this.checkPhoneOrICD();
            if (!phoneOrIcd) {
              this.errorContact = ['( Số điện thoại này chưa tồn tại trên hệ thống. Vui lòng thêm contact trên crm )']
              return
            }
          } else {
            return
          }
        }
        const cleanPackageData = this.packageData.map(pkg => {
          const cleanPkg = { ...pkg };
          // eslint-disable-next-line no-prototype-builtins
          if (cleanPkg.hasOwnProperty('amountError')) {
            delete cleanPkg.amountError;
          }
          return cleanPkg;
        });

        const data = {
          originContactId: contactId,
          originCustomerId: this.student && this.student.customer_id ? this.student.customer_id : null,
          newContactId: this.typeTransfer === 1 ? contactId : phoneOrIcd ,
          oldPackageList: cleanPackageData,
          newProducts: products,
          totalRemainAmount: this.totalRemainAmount,
          totalNewProductsAmount: this.totalMoney,
          typeTransfer: {
            id: this.typeTransfer
          },
          paymentMethod: {
            id: this.paymentMethod
          },
          conversionMethod: {
            id: this.conversionMethod
          }
        }
        if (this.paymentMethod === 2 && Number(this.totalMoney) <= Number(this.totalRemainAmount)) {
          this.$swal({
            icon: 'error',
            type: 'error',
            text: '“Tổng giá trị mới” nhỏ hơn hoặc bằng “Tổng số tiền còn lại”. Không thể thanh toán thêm ',
            showConfirmButton: true,
            timer: 2500,
          });
          return
        }
        if(this.paymentMethod === 1 && !this.isTutor && this.totalRemainAmount < this.totalMoney && this.conversionMethod === 1) {
          return this.$swal({
            icon: 'error',
            type: 'error',
            text: '“Tổng giá trị mới” lớn hơn tổng số tiền còn lại. Vui lòng chọn sản phẩm nhận phí khác.',
            showConfirmButton: true,
            timer: 2500,
          });
        }
        try {
          const response = await TransferFeeDuo.createCrossFeeTransferProductApi(this.urlCRM, data)
          if(response.success) {
            this.recordId =  response.data && response.data._id ? response.data._id : null
            if(this.recordId) {
              if(this.paymentMethod === 1) {
                if(this.typeTransfer === 1) {
                  await this.getPreviewTransferApi(this.recordId)
                } else {
                  const currentPath = this.$route.fullPath;
                  const dataParams = {
                    isDuo: true,
                    idTransfer: true,
                    record_id: this.recordId,
                    url_back: currentPath,
                  }
                  await this.$router.replace({ name: 'UpdateContactInfo', params: { id: phoneOrIcd }, query: { ...dataParams } });
                }
              } else {
                const currentPath = this.$route.fullPath;
                const urlCRM = process.env.VUE_APP_CRM;
                window.open(`${urlCRM}/contact/contact-list/${this.typeTransfer === 1 ? contactId : phoneOrIcd}/update-contact-info?record_type=transfer_product${ this.typeTransfer === 2 ? "&idTransfer=true": '' }&isDuo=true&record_id=${this.recordId}&url_back=${currentPath}`, '_blank');
                this.$emit('close');
              }
            }
          }else {
            this.$swal({
              icon: 'error',
              type: 'error',
              text: response.message,
              showConfirmButton: true,
              timer: 2500,
            });
          }
        }catch (e) {
          this.$swal({
            icon: 'error',
            type: 'error',
            text: e.response.data.message,
            showConfirmButton: true,
            timer: 2500,
          });
          console.log(e)
        }
      }else {
        this.$swal({
          icon: "error",
          title: "Thông báo",
          text: "Vui lòng chọn sản phẩm nhận phí.",
        });
      }
    },
    formatCurrency(amount) {
      if (!amount) return '0';
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

  },
};
</script>
<style scoped>
.v-data-table {
  background-color: transparent !important;
}

.v-autocomplete ::placeholder {
  font-style: italic !important;
}

.border-right {
  border-right: 1px solid #e0e0e0;
  padding-right: 24px;
}

.timeline {
  position: relative;
  padding-left: 8px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 11px;
  top: 0;
  height: 100%;
  width: 2px;
  background-color: #6F44FF;
  opacity: 0.3;
}

.timeline-item {
  position: relative;
  margin-bottom: 24px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -7.5px;
  top: 0;
  z-index: 2;
  background: white;
}

.timeline-dot-2 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  background: white;
}

.timeline-content {
  padding-left: 24px;
}

.custom-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  table {
    background: #fff !important;
  }
}

.custom-table ::v-deep td {
  font-size: 14px !important;
}

.custom-table ::v-deep th {
  color: #5D62D1 !important;
  border-right: 1px solid #FFF;
}

.custom-table ::v-deep th:last-child {
  color: #5D62D1 !important;
  border-right: 0 solid #FFF !important;
}

.custom-table-2 ::v-deep th, .custom-table ::v-deep th {
  font-weight: 500 !important;
  font-size: 13px !important;
  height: 36px !important;
}

.timeline-header {
  display: flex;
  align-items: center;
}

.transfer-fee {
  input {
    font-size: 14px !important;
  }

  .v-text-field__details {
    padding-left: 0 !important;
  }
}

.caption {
  font-size: 0.75rem;
  color: #757575;
}

</style>
<style lang="scss">
.v-input {
  &.text-field-number {
    .v-input__control {
      .v-input__slot {
        .v-input__append-inner {
          display: none !important;
        }
      }
    }
  }
}

.text-field-number input[type="number"]::-webkit-outer-spin-button,
.text-field-number input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.text-field-number input[type="number"] {
  -moz-appearance: textfield;
}

.custom-select-outlined-submodule1 {
  .v-input__control {
    height: 38px;
  }

  fieldset {
    height: 38px;
  }

  .v-select__slot {
    font-size: 12px;
    width: 160px;
    height: 35px;

    .v-input__append-inner {
      margin-top: 4px;
    }

    .v-select__selections {
      padding: 0px !important;
    }
  }

  .v-text-field__details {
    display: none;
  }
}
.table-package-detail.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 8px !important;
}
.table-package-detail {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  border: 1px solid #E0E0E0 !important;
  .v-data-table__wrapper > table > thead > tr > th {
    color: #5D62D1 !important;
    padding: 8px !important;
    border: 1px solid white !important;
    font-size: 13px !important;
  }
  .v-data-table__wrapper > table > thead > tr > th.th-01 {
    background: #EBECFF !important;
  }
  .v-data-table__wrapper > table > thead > tr > th.pink-th-01 {
    background: #FFEBF9 !important;
  }
  .v-data-table__wrapper > table > thead > tr > th.pink-th-02 {
    background: #FFEAEA !important;
  }
  .v-data-table__wrapper > table > thead > tr > th.pink-th-03 {
    background: #FFF1E5 !important;
  }

  .v-data-table__wrapper > table > thead > tr > th.first-child-th:first-child {
    border-top-left-radius: 10px !important;
  }

  .v-data-table__wrapper > table > thead > tr > th.last-child-th:last-child {
    border-top-right-radius: 10px !important;
  }

  tr td {
    color: #000 !important;
    border: 1px solid #E0E0E0 !important;
  }
}
.btn-next {
  background-color: #ff5500 !important;
  color: white !important;
  border: 1px solid #ff5500 !important;
  border-radius: 999px !important;
}
.btn-next.v-btn--disabled {
  background-color: #fff !important;
  color: #dadada !important;
  border: 1px solid #dadada !important;
}

</style>
